import { Action } from "@ngrx/store";

export const ENTITY = "network";
export const SET_AUTHENTICATED = "[Network] Last Sync Down";
export const SET_ONLINE = "[Network] Online";
export const SET_ONLINE_AND_AUTHENTICATED = "[Network] Online and Authenticated";

export class SetAuthenticated implements Action {
    readonly type = SET_AUTHENTICATED;

    constructor(public payload: boolean) {
    }
}

export class SetOnline implements Action {
    readonly type = SET_ONLINE;

    constructor(public payload: boolean) {
    }
}

export class SetOnlineAuthenticated implements Action {
    readonly type = SET_ONLINE_AND_AUTHENTICATED;

    constructor(public online: boolean, public authenticated: boolean) {
    }
}

export type Actions
    = SetAuthenticated
    | SetOnline
    | SetOnlineAuthenticated;



// WEBPACK FOOTER //
// ./src/core/business-objects/network/network.actions.ts